<template>
  <v-parallax class="banner-container mt-8" height="96" :src="getImgUrl()">
    <div class="heading-h3 banner-content">Welcome. {{ userName }}</div>
  </v-parallax>
</template>

<script>
  export default {
    name: "WelcomeBanner",

    props: ["userName"],

    computed: {
      user() {
        return this.$store.getters.userInfo;
      },
    },

    methods: {
      getImgUrl() {
        if (this.user.role === "parent") {
          return require("@/assets/parent_bcg_img.png");
        } else {
          return require("@/assets/kids_bcg_img.png");
        }
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/WelcomeBanner.vue